module.exports = __webpack_public_path__ + "img/13_climate_action_color.7d18c5b9.svg";